/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Blank, Pagination, TechwiseNotification } from "../../utils/Interfaces";
import { getHandler, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AxiosResponse } from "axios";
import { pushUpdatedNotifications } from "./notificationsSlice";

export function updateNotifications(dispatch: Dispatch<AnyAction>): void {
    getHandler<Pagination<TechwiseNotification>>(
        "/api/notifications/list",
        dispatch,
        (response: AxiosResponse<Pagination<TechwiseNotification>, any>) =>
            dispatch(pushUpdatedNotifications(response.data.results)),
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function dismissNotification(notificationId: number, dispatch: Dispatch<AnyAction>): void {
    postHandler<Blank, Blank>(
        `/api/notifications/dismiss/${notificationId}`,
        {},
        dispatch,
        // There is no need for a custom callback onSuccess for this function since it will always update the
        // notifications after dismissing a notification.
        () => updateNotifications(dispatch),
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function dismissAllNotifications(dispatch: Dispatch<AnyAction>): void {
    postHandler<Blank, Blank>(
        "/api/notifications/dismiss-all",
        {},
        dispatch,
        // There is no need for a custom callback onSuccess for this function since it will always update the
        // notifications after dismissing a notification.
        () => updateNotifications(dispatch),
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}
